import React from "react";
import { config } from "../config";
import { useInView } from 'react-intersection-observer';
import { Link } from "react-router-dom";
import why from "../../assets/images/set.jpg";

const ServiceSection = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <>
      <div class="marquee">
        <div class="marquee__track">
          <span>Diamonds</span><span class="dot">✦</span>
          <span>Gold</span><span class="dot">✦</span>
          <span>Sapphires</span><span class="dot">✦</span>
          <span>Emeralds</span><span class="dot">✦</span>
          <span>Platinum</span><span class="dot">✦</span>
          <span>Rubies</span><span class="dot">✦</span>
          <span>Pearls</span><span class="dot">✦</span>
          <span>Diamonds</span><span class="dot">✦</span>
          <span>Gold</span><span class="dot">✦</span>
          <span>Sapphires</span><span class="dot">✦</span>
          <span>Emeralds</span><span class="dot">✦</span>
          <span>Platinum</span><span class="dot">✦</span>
          <span>Rubies</span><span class="dot">✦</span>
          <span>Pearls</span><span class="dot">✦</span>
        </div>
      </div>

      <div className="features-area pt-80 pb-80 bg-f7fafd">
        <div className="container">

          <div className="row">
            <div
              className={`col-lg-6 col-md-6 aos-init aos-animate box-animate ${inView1 ? 'visible' : ''}`} ref={ref1}
            >
              <div className="about-info">
                <div class="section-header mb-3">
                  <span class="section-tag">Why Choose Us</span>
                  <h2>Timeless Pieces That Endure</h2>
                </div>
                <p>
                  Maa vaishno jewellers is dedicated to crafting exquisite jewellery that reflects tradition, purity, and elegance. Each piece is thoughtfully designed to celebrate life’s most meaningful moments, blending heritage craftsmanship with contemporary style.</p>
                <p>
                  Our collection features a wide range of gold, diamond, and gemstone jewellery, carefully handcrafted by skilled artisans. From everyday elegance to bridal masterpieces, every creation is made with precision, ensuring unmatched quality and brilliance. </p>
                <p>
                  We are committed to trust and authenticity, offering hallmarked jewellery that stands the test of time. At Maa vaishno jewellers, we don’t just create ornaments. we create memories that you cherish forever. </p>
              </div>
            </div>
            <div
              className={`col-lg-6 col-md-6 aos-init aos-animate box-animate ${inView2 ? 'visible' : ''}`} ref={ref2}
            >
              <div className="img-why">
                <img src={why} style={{ width: "100%" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceSection;
